import * as consts from '../../constants.js';

export default {
  dataLanguagesStatus: consts.REQUEST_WITHOUT_STARTING,
  languages: [],
};
